<div>
    <div class="modal-header col-12" style="justify-content: flex-end; margin-bottom: 0; border: none;">
      <img title="Close Modal" (click)="closeModal(false)" width="17" height="17" src="assets/images/cross-dark-grey.svg" style="cursor: pointer;">
    </div>
    <div class="modal-body">
      <h2 class="modal-title col-12 noTextSelect">Remove Items?</h2>
      <h3 class="deleteMsg mt-4"><span class="noTextSelect">The order date has been passed. Are you sure you want to remove?</span></h3>
    </div>

    <div class="modal-footer removeItem col-12" (click)="closeModal(true)">
      <p class="noTextSelect" style="margin: 0px;">YES CONFIRM</p>
      </div>
  </div>



// WEBPACK FOOTER //
// ./src/app/modules/shared/remove-cart-past-order/remove-past-order.component.html